
import { useNavigate } from "react-router-dom";
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutTabla } from "../../layout";
import { AlertScreen } from "../components/AlertScreen";
import { separadorMillares } from "../../../helpers";
import { useFacturasStore } from "../../../store";

import dayjs from 'dayjs';







export const TablaFacturas = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalFacturas } = useFacturasStore();


    return (

        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalFacturas / 50)} disabled={Math.ceil(totalFacturas / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'20%'}}>Numero</TableCell>
                        <TableCell sx={{width:'20%'}}>Proveedor</TableCell>
                        <TableCell sx={{width:'10%'}}>Items</TableCell>
                        <TableCell sx={{width:'10%'}}>Total</TableCell>
                        <TableCell sx={{width:'15%'}}>Vence</TableCell>
                        <TableCell sx={{width:'10%'}}>Pago</TableCell>
                        <TableCell sx={{width:'10%'}}>Recibido</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (d) => (
                        <TableRow key={d.id} sx={{cursor:'pointer'}} onClick={ () => navigate(`/admin/facturas/${d.id}/opcion`) }> 
                            <TableCell >{ dayjs(d.fechaCreacion || d.createdAt).format('DD MMM YYYY').toUpperCase() }</TableCell>
                            <TableCell >{ d.numero }</TableCell>
                            <TableCell>{ d.proveedor.nombre }</TableCell>
                            <TableCell>{ d.productos.length }</TableCell>
                            <TableCell>{ `$${separadorMillares(d.total)}` }</TableCell>
                            <TableCell>
                                {(d.vencimiento) 
                                ?   dayjs(d.vencimiento).format("DD MMM YYYY").toUpperCase()
                                :   <span style={{ color:"red", fontWeight:"bold" }}>
                                        No aplica 
                                    </span>
                                }
                            </TableCell>
                            <TableCell>{ d.formaPago}</TableCell>
                            <TableCell>
                                {(d.ingresadoBodega) 
                                ?   'SI'
                                :   <span style={{ color:"red", fontWeight:"bold" }}>
                                        NO
                                    </span>
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        : <AlertScreen title="No hay facturas por el momento..." />
        }
        </>
    )
}
